var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83536 0.461623C8.1054 0.0713084 8.57357 -0.0927712 9.00406 0.052028C9.43454 0.196827 9.73398 0.619103 9.75156 1.10616V8.58973H15.9515C16.3401 8.59607 16.6947 8.83089 16.8764 9.20234C17.0582 9.57378 17.0383 10.0228 16.8244 10.3737L9.15967 22.4819C8.88962 22.8722 8.42145 23.0362 7.99097 22.8914C7.56049 22.7466 7.26105 22.3244 7.24347 21.8373V14.3538H1.04777C0.65882 14.3471 0.30418 14.1116 0.122802 13.7396C-0.0585757 13.3675 -0.037807 12.9181 0.176971 12.5675L7.83536 0.461623Z",
    fill: "#FFB000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentIcon);
export default __webpack_public_path__ + "static/media/recentIcon.df6ca3b8897a3336567fb9cbb805fca5.svg";
export { ForwardRef as ReactComponent };